jQuery(document).ready(function($) {

    $('.carousel-slides').slick({
        infinite        : true,
        slidesToShow    : 5,
        slidesToScroll  : 1,
        arrows: true,
        prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-chevron-left' aria-hidden='true'></i></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-chevron-right' aria-hidden='true'></i></button>",
            responsive: [
                {
                  breakpoint: 1098,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 896,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {
                    breakpoint: 769,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 550,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                }

              ]
      });
      
      
      $('.carousel-slides').slickLightbox({
        src: 'data-lightbox',
        itemSelector        : '.carousel-slide .slide-overlay',
        navigateByKeyboard  : true,
        closeOnBackdropClick : false,
        caption:function(element, info) {
            var span=$(element).parent().find(".desc");
            return span.html(); }
      });

      // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.wf-carousel').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=wf-carousel-block', initializeBlock );
    }

});